export const setWhatWeProvideSectionData = (
  model,
  setModel,
  ele,
  property,
  locale = false,
  language = null
) => {
  console.log("=================");
  console.log("model",model);
  console.log("setModel",setModel);
  console.log("ele",ele);
  console.log("property",property);
  console.log("locale",locale);
  console.log("language",language);
  console.log("=================");
  
  // Create a deep copy of the model and its locales array
  let newData = {
    ...model,
    locales: model?.locales ? [...model.locales] : []
  };

  if (locale) {
    let existsLocales = newData.locales.filter((i) => {
      return i?.locale === language;
    });
    
    if (existsLocales?.length) {
      // Create a copy of the locale object before modifying
      const localeIndex = newData.locales.findIndex(i => i.locale === language);
      newData.locales[localeIndex] = {
        ...newData.locales[localeIndex],
        [ele.target.name]: ele.target.value
      };
    } else {
      newData.locales.push({ 
        locale: language,
        [ele.target.name]: ele.target.value
      });
    }
  } else {
    if (ele.target.name === "image") {
      if (ele.target.files.length) {
        newData["image"] = ele.target.files[0];
      }
    } else {
      newData[property] = ele.target.value;
    }
  }
  
  setModel(newData);
};







// export const setWhatWeProvideSectionData = (
//     model,
//     setModel,
//     ele,
//     property,
//     locale = false,
//     language = null
//   ) => {
//     console.log("=================");
//     console.log("model",model);
//     console.log("setModel",setModel);
//     console.log("ele",ele);
//     console.log("property",property);
//     console.log("locale",locale);
//     console.log("language",language);
//     console.log("=================");
    
//     let newData = Object.assign({}, model);
  
//     if (locale) {
//       let existsLocales = model?.locales?.filter((i) => {
//         return i?.locale === language;
//       });
//       if (existsLocales?.length) {
//         existsLocales[0][ele.target.name] = ele.target.value;
//       } else {
//         model?.locales?.push({ locale: language });
//         model?.locales?.map((i) => {
//           if (i.locale === language) {
//             i[ele.target.name] = ele.target.value;
//           }
//           return true;
//         });
//       }
//     } else {
//       if (ele.target.name === "image") {
//         if (ele.target.files.length) {
//           newData["image"] = ele.target.files[0];
//         }
//       } else {
//         newData[property] = ele.target.value;
//       }
//     }
//     setModel(newData);
//   };
  